import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { customerApi, formatApiErrorDetail } from "@/lib/api";
import SEO from "@/components/SEO";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await customerApi.post("/customer/reset-password", { token, password });
      setDone(true);
      toast.success("Passwort geändert. Du kannst dich jetzt anmelden.");
      setTimeout(() => navigate("/anmelden", { replace: true }), 1500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Fehler.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="on-dark violet-canvas flex-1 w-full flex items-center justify-center px-5 py-20">
      <SEO title="Passwort zurücksetzen" />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo variant="butterfly" className="h-14 w-auto mx-auto mb-4" />
          <h1 className="font-serif text-4xl font-light text-[#FFF9F2]">Neues Passwort</h1>
        </div>
        {!token ? (
          <div className="bg-[#FFF9F2] rounded-md p-7 text-center">
            <p className="text-[#3A1E55]">Ungültiger oder fehlender Link.</p>
            <Link to="/passwort-vergessen" className="mt-4 inline-block text-[#632A8E] underline">Neuen Link anfordern</Link>
          </div>
        ) : done ? (
          <div className="bg-[#FFF9F2] rounded-md p-7 text-center" data-testid="reset-success">
            <p className="text-[#3A1E55]">Dein Passwort wurde geändert. Weiterleitung zur Anmeldung…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5 bg-[#FFF9F2] rounded-md p-7" data-testid="reset-form">
            <div>
              <Label htmlFor="rp-pw">Neues Passwort (mind. 6 Zeichen)</Label>
              <Input id="rp-pw" data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
            <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full bg-[#F4C542] text-[#32104F] hover:bg-[#D85CA4] rounded-md h-12">
              {loading ? "Speichern…" : "Passwort speichern"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
